module.exports = __webpack_public_path__ + "static/media/flutter.f7926470.png";